import { statusConstants } from '../_constants';

export function status(state = {}, action) {
  switch (action.type) {
    case statusConstants.SUCCESS:
      return {
        type: 'alert-success',
        message: action.error,
        errors: '',
      };
    case statusConstants.ERROR:
      return {
        type: 'alert-danger',
        message: action.error.message,
        errors: action.error.errors,
      };
    case statusConstants.CLEAR:
      return {};
    default:
      return state
  }
}